import React, { useMemo, useState } from "react";
import { Bell, Download } from "lucide-react";
import { useInstallPrompt } from "../../hooks/useInstallPrompt";
import downloadIcon from "./download.png";

const PwaInstallTrigger = ({
  mode = "inline",
  className = "",
  text = "For better UI experience",
}) => {
  const { isIOS, isInstalled, canInstall, install } = useInstallPrompt();
  const [showIOSHint, setShowIOSHint] = useState(false);

  const shouldRender = useMemo(
    () => !isInstalled && (canInstall || isIOS),
    [canInstall, isIOS, isInstalled],
  );

  if (!shouldRender) {
    return null;
  }

  const handleOpenPrompt = async () => {
    if (canInstall) {
      await install();
      return;
    }

    if (isIOS) {
      setShowIOSHint(true);
    }
  };

  const actionLabel = canInstall ? "Download" : "How to Add";

  if (mode === "icon") {
    return (
      <>
        <button
  type="button"
  onClick={handleOpenPrompt}
  aria-label="Install MathDingo app"
  title="Install MathDingo app"
  className={`block md:hidden relative inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-[#0B2B66] shadow-[0_1px_2px_rgba(11,43,102,0.18)] transition hover:-translate-y-0.5 hover:bg-[#e9faff] ${className}`}
>
  <img src={downloadIcon} alt="Download App" className="w-5 h-5 object-contain" />
</button>

        {showIOSHint && (
          <IOSInstallHint onClose={() => setShowIOSHint(false)} />
        )}
      </>
    );
  }

  return (
    <>
      <div
        className={`flex w-full items-center gap-2 rounded-2xl bg-white/75 px-4 py-3 text-center shadow-[0_10px_30px_rgba(8,5,155,0.12)] backdrop-blur-sm ${className}`}
      >
        <p className="text-sm font-semibold text-[#0B2B66]">{text}</p>
        <button
          type="button"
          onClick={handleOpenPrompt}
          className="inline-flex items-center gap-2 rounded-full bg-[#08059B] px-4 py-2 text-sm font-bold text-white shadow-md transition hover:bg-[#0B2B66]"
        >
          <Download size={16} />
          {actionLabel}
        </button>
      </div>

      {showIOSHint && <IOSInstallHint onClose={() => setShowIOSHint(false)} />}
    </>
  );
};

const IOSInstallHint = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-[#071733]/55 px-4 backdrop-blur-sm">
      <div className="w-full max-w-sm rounded-3xl bg-white px-6 py-6 text-center shadow-[0_20px_50px_rgba(7,23,51,0.32)]">
        <h3 className="text-xl font-extrabold text-[#0B2B66]">
          Add MathDingo
        </h3>
        <p className="mt-3 text-sm font-medium leading-6 text-[#42526b]">
          On iPhone or iPad, tap the Share button in Safari and choose Add to
          Home Screen.
        </p>
        <button
          type="button"
          onClick={onClose}
          className="mt-5 rounded-full bg-[#08059B] px-5 py-2 text-sm font-bold text-white"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default PwaInstallTrigger;
